import { ShowFeatureQuery, ShowFeatureQueryVariables } from '@/typings/domain'
import apolloClient from './apolloClient'
import ShowFeatureGQL from './graphql/ShowFeature.graphql'

/** `forBillingAccountOwner` reads the toggle for the billing account (its owner's email) instead of the user. */
export function fetchShowFeature(key: string, options: Omit<ShowFeatureQueryVariables, 'key'> = {}) {
  return apolloClient.query<ShowFeatureQuery, ShowFeatureQueryVariables>({
    query: ShowFeatureGQL,
    variables: { key, ...options },
    fetchPolicy: 'no-cache',
  })
}
